// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

ion-content.badge-enroll-content {
  --padding-bottom: 64px;
}

.badge-row-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.badge-row-actions ion-badge {
  flex: 0 0 auto;
}

.badge-row-actions ion-button {
  margin: 0;
}

.badge-print-card {
  text-align: center;
  padding: 16px;
  border: 1px solid var(--ion-color-medium, #cccccc);
  border-radius: 8px;
}

.badge-print-operatore {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 8px;
}

.badge-preview-hidden {
  display: none !important;
}

.badge-print-symbol {
  display: block;
  max-width: 100%;
  margin-inline: auto;
}

.badge-print-codice {
  font-family: monospace;
  font-size: 16px;
  letter-spacing: 1px;
  margin: 8px 0 0;
}

@media print {
  .no-print {
    display: none !important;
  }
  ::ng-deep body.printing-badge {
    visibility: hidden;
  }
  ::ng-deep body.printing-badge .badge-print-card,
  ::ng-deep body.printing-badge .badge-print-card * {
    visibility: visible;
  }
  ::ng-deep body.printing-badge .badge-print-card {
    position: fixed;
    inset: 0;
    margin: auto;
    height: fit-content;
    border: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/_components/badge/badge-enroll/badge-enroll.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,kDAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EAEE;IACE,wBAAA;EAAF;EAKA;IACE,kBAAA;EAHF;EAMA;;IAEE,mBAAA;EAJF;EAOA;IACE,eAAA;IACA,QAAA;IACA,YAAA;IACA,mBAAA;IACA,YAAA;EALF;AACF","sourcesContent":[":host {\n  display: block;\n}\n\nion-content.badge-enroll-content {\n  --padding-bottom: 64px;\n}\n\n.badge-row-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.badge-row-actions ion-badge {\n  flex: 0 0 auto;\n}\n\n.badge-row-actions ion-button {\n  margin: 0;\n}\n// Anteprima a schermo della tessera stampabile (codice + simbolo + operatore)\n.badge-print-card {\n  text-align: center;\n  padding: 16px;\n  border: 1px solid var(--ion-color-medium, #cccccc);\n  border-radius: 8px;\n}\n\n.badge-print-operatore {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0 0 8px;\n}\n\n.badge-preview-hidden {\n  display: none !important;\n}\n\n.badge-print-symbol {\n  display: block;\n  max-width: 100%;\n  margin-inline: auto;\n}\n\n.badge-print-codice {\n  font-family: monospace;\n  font-size: 16px;\n  letter-spacing: 1px;\n  margin: 8px 0 0;\n}\n\n@media print {\n  // In stampa nasconde la chrome del modale, lasciando solo la tessera.\n  .no-print {\n    display: none !important;\n  }\n\n  // Isolamento globale gated su .printing-badge (impostata da printCard()):\n  // nasconde l'intera pagina e mostra la sola tessera, senza leak ad altre stampe.\n  ::ng-deep body.printing-badge {\n    visibility: hidden;\n  }\n\n  ::ng-deep body.printing-badge .badge-print-card,\n  ::ng-deep body.printing-badge .badge-print-card * {\n    visibility: visible;\n  }\n\n  ::ng-deep body.printing-badge .badge-print-card {\n    position: fixed;\n    inset: 0;\n    margin: auto;\n    height: fit-content;\n    border: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
